export class MyCONST {
  public static AppBaseURL = 'CMOI';
  /*
  localstorage Constant
   */
  public static username = 'uname';
  public static Token = '_token';
  public static RefreshToken = '_refreshToken';
  public static authenticated = '_authenticated';

  public static IsLogin = 'IsLogin';
  static SELECTED_GROUP = 'SELECTED_GROUP';
  static LISTGROUPS = 'LISTGROUPS';
  static MAIN_SERVICE_TABS_INDEX = 'MAIN_SERVICE_TABS_INDEX';
  static SELECTED_PROVIDER = 'SELECTED_PROVIDER';
  static ALL_SERV_PROVIDERS = 'ALL_SERV_PROVIDERS';
  static ALL_SELECT_SERV_PROVIDERS = 'ALL_SELECT_SERV_PROVIDERS';
  static ALL_SERVICES = 'ALL_SERVICES';
  static ALL_SELECT_SERVICES = 'ALL_SELECT_SERVICES';
  static SELECTED_ITEM_PVDR = 'SELECTED_ITEM_PVDR';
  static HISTORY_DATE_FILTER = 'HISTORY_DATE_FILTER';
  static HISTORY_CLAIM_FILTER = 'HISTORY_CLAIM_FILTER';
  static HISTORY_SIMSTATISTICS_FILTER = 'HISTORY_SIMSTATISTICS_FILTER';
  static LANG = 'LANG';

  static BAS_URL = 'https://apiv2.creditemoi.com/api/v2/';
  static BAS_URL_MULTI = 'https://api.country_pays.creditemoi.com/api/v2/';
  static MULTI_SITE = 1;
  static DEV_BAS_URL = '/dev/';
  static DEFAULT_IMG = 'https://apiv2.creditemoi.com/i1.PNG';

  static SOCKET_URL = 'https://apiv2.creditemoi.com/';
  static SOCKET_URL_MULTI = 'https://api.country_pays.creditemoi.com/';
  static DEV_SOCKET_URL = '/webs/';

  static PENDING_TRANSACTIONS = 'PENDING_TRANSACTIONS';
  static PENDING_PAYMENTS = 'PENDING_PAYMENTS';
  static PENDING_USERS = 'PENDING_USERS';
  static PENDING_CLAIMS = 'PENDING_CLAIMS';
  static PENDING_CLAIMS_STATUS = 'PENDING_CLAIMS_STATUS';

  static PENDING_TRANSACTIONS_DB = 'PENDING_TRANSACTIONS_DB';
  static PENDING_PAYMENTS_DB = 'PENDING_PAYMENTS_DB';
  static PENDING_USERS_DB = 'PENDING_USERS_DB';
  static PENDING_CLAIMS_DB = 'PENDING_CLAIMS_DB';
  static PENDING_CLAIMS_STATUS_DB = 'PENDING_CLAIMS_STATUS__DB';

  static NAVIGATOR_DB = 'NAVIGATOR_DB';
  static label_color = 'rgba(255,255,255,1)';
  static TRANSACTIONS_BULK_TEMPLATE = './assets/template/template_transactions_creditemoi.xlsx';
  static PAYMENTS_BULK_TEMPLATE = './assets/template/template_payment_creditemoi.xlsx';
  static USERS_BULK_TEMPLATE = './assets/template/template_users_creditemoi.xlsx';
  static CLAIMS_BULK_TEMPLATE = './assets/template/template_claims_creditemoi.xlsx';
  static TEST_PWD = '';

  //PAYMENT CONST
  static STRIPE_SERVICE_ITEM_ID = '60';
}
